import React, { FC } from 'react';
import { NO_TOPIC, TOPIC_ICONS, TopicChoice } from '../comuni-helper';
import { LuCheck } from 'react-icons/lu';
import { COMUNI_TOPICS } from '../constants';
import { useTranslation } from 'react-i18next';
import { useNewCommunicationValues } from './context/useNewCommunicationValues';
import { useNewCommunicationActions } from './context/useNewCommunicationActions';
import { WizardNav } from '../components/WizardNav';

const TopicCard: FC<{ id: TopicChoice; label: string; selected: boolean; onSelect: (id: TopicChoice) => void }> = ({ id, label, selected, onSelect }) => {
  const Icon = TOPIC_ICONS[id];
  //   const selected = topic === id;
  return (
    <button
      key={id}
      type='button'
      onClick={() => onSelect(id)}
      className={`relative flex flex-col gap-3.5 rounded-[14px] border p-5 text-left ${
        selected ? 'border-2 border-brand-600 bg-brand-50 p-[19px]' : 'bg-white-100 hover:border-brand-200'
      }`}
    >
      {selected && (
        <span className='absolute right-3 top-3 flex size-[22px] items-center justify-center rounded-full bg-brand-700'>
          <LuCheck className='size-3 text-white-100' strokeWidth={3} />
        </span>
      )}
      <span className='flex size-11 items-center justify-center rounded-xl bg-brand-50'>
        <Icon className='size-6 text-brand-700' />
      </span>
      <span className='text-[15px] font-semibold leading-snug'>{label}</span>
    </button>
  );
};

export const TopicStepContainer = () => {
  const { t } = useTranslation('comuni');
  const { commName, topic } = useNewCommunicationValues();
  const { setTopic, setCommName, handleTopicNext, goToPreviousStep } = useNewCommunicationActions();

  return (
    <section className='mt-6 rounded-2xl border px-10 py-9'>
      <h3 className='text-[26px] font-extrabold tracking-tight text-primary-900'>{t('topic.title')}</h3>
      <p className='mt-1.5 text-[15px] text-tertiary-600'>{t('topic.subtitle')}</p>

      <div className='mt-6 max-w-md'>
        <div className='text-[11.5px] font-bold uppercase tracking-wide text-quaternary-400'>{t('topic.nameLabel')} *</div>
        <input
          id='comuni-comm-name'
          name='comuni-comm-name'
          type='text'
          className='mt-1.5 w-full rounded-md border-brand-600 px-3 py-2.5 focus:outline-none focus:ring-0'
          placeholder={t('newCommunicationNamePlaceholder')}
          value={commName}
          onChange={(event) => setCommName(event.target.value)}
        />
        <p className='mt-1.5 text-[12.5px] text-tertiary-600'>{t('topic.nameHint')}</p>
      </div>

      <div className='mt-6 grid gap-4 [grid-template-columns:repeat(auto-fill,minmax(205px,1fr))]'>
        <TopicCard id={NO_TOPIC} label={t('topic.none')} selected={topic === NO_TOPIC} onSelect={(id) => setTopic(id)} />
        {COMUNI_TOPICS.map((topicId) => {
          const selected = topicId === topic;
          return <TopicCard key={topicId} id={topicId} label={t(`topics.${topicId}`)} selected={selected} onSelect={(id) => setTopic(id)} />;
        })}
      </div>
      <WizardNav primaryText={t('composer.next')} onPrimary={handleTopicNext} primaryDisabled={!commName.trim()} onBack={goToPreviousStep} />
    </section>
  );
};
